<template>
  <div class="lesson-view m-0 p-0">
    <swiper
      v-if="descriptions.length > 1"
      :slidesPerView="'1'"
      navigation
      :pagination="{ clickable: true }"
      :autoHeight="true"
      @slideChange="detectLastSlide"
    >
      <swiper-slide v-for="(descrip, index) in descriptions" :key="index">
        <div class="pb-4">
          <vue-markdown :source="descrip">
            {{ descrip }}
          </vue-markdown>
        </div>
      </swiper-slide>
    </swiper>

    <p v-else>
      <vue-markdown :source="description">
        {{ this.description }}
      </vue-markdown>
    </p>

    <div
      class="col text-center mt-8"
      v-if="
        (hasFinalPractice && descriptions.length <= 1) ||
        (hasFinalPractice && isLastSlide)
      "
      :class="{ 'mt-8': isLastSlide }"
    >
      <button
        class="mob-btn mob-cta-gold-outline ml-3"
        @click="startFinalPractice()"
      >
        Ver Práctica final
      </button>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination]);

export default {
  name: "LessonDescription",
  components: {
    VueMarkdown,
    Swiper,
    SwiperSlide,
  },

  props: {
    description: String,
    hasFinalPractice: Boolean,
  },
  data() {
    return {
      descriptions: this.description.split("--break--"),
      isLastSlide: false,
    };
  },
  methods: {
    startFinalPractice() {
      this.$emit("goToFinalPractice");
    },
    detectLastSlide(swiper) {
      this.isLastSlide = swiper.activeIndex === swiper.slides.length - 1;
    },
  },
};
</script>

<style>
.lesson-view .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -7px;
}

.swiper-pagination,
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  bottom: 0px;
  top: auto;
}

.swiper-button-prev {
  left: 10px;
}

.swiper-button-next {
  right: 10px;
}

.lesson-view h1,
.lesson-view h2,
.lesson-view h3,
.lesson-view h4,
.lesson-view h5,
.lesson-view h6 {
  margin-top: 0 !important;
  margin-bottom: 0.5rem !important;
}

.lesson-view h1,
.lesson-view h2,
.lesson-view h3,
.lesson-view h4,
.lesson-view h5,
.lesson-view h6,
.lesson-view .h1,
.lesson-view .h2,
.lesson-view .h3,
.lesson-view .h4,
.lesson-view .h5,
.lesson-view .h6 {
  margin-bottom: 0.5rem !important;
  font-weight: 400 !important;
  line-height: 1.2 !important;
}

.lesson-view h1,
.lesson-view .h1 {
  font-size: 2.5rem !important;
}

.lesson-view h2,
.lesson-view .h2 {
  font-size: 2rem !important;
}

.lesson-view h3,
.lesson-view .h3 {
  font-size: 1.75rem !important;
}

.lesson-view h4,
.lesson-view .h4 {
  font-size: 1.5rem !important;
}

.lesson-view h5,
.lesson-view .h5 {
  font-size: 1.25rem !important;
}

.lesson-view h6,
.lesson-view .h6 {
  font-size: 1rem !important;
}
</style>
